import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';

import CustomRipples from '../common/custom-ripples';

import { useFormatMessage } from '../../intl/intl';
import { selectors as partnerSelectors } from '../../redux/partner';

import useStyles from './styles';

const OrderInfoKanbanCardSection = props => {
  const {
    classes = {},
    onClick = () => {},
    orderId = 0,
    ripples = false,
    showBullet = false,
    storeName = '',
    orderCreationStatus = '',
  } = props;

  const componentClasses = useStyles({ ripples, orderCreationStatus });

  return (
    <CustomRipples
      classes={{ root: classNames(componentClasses.root, classes.root) }}
      onClick={onClick}
      ripples={ripples}
    >
      {showBullet && (
        <div className={componentClasses.circleContainer}>
          <div className={componentClasses.circle}></div>
        </div>
      )}
      <div className={componentClasses.orderInfoContainer}>
        <div className={componentClasses.orderId}>{`ID: ${orderId}`}</div>
        {!!storeName && (
          <div className={componentClasses.storeName}>{storeName}</div>
        )}
      </div>
    </CustomRipples>
  );
};
export default OrderInfoKanbanCardSection;
